module.exports = __webpack_public_path__ + "img/online1.c9b3a065.jpeg";